package game.scenes;

import cerastes.pass.SubtractionFilter;
import cerastes.ui.AdvancedText;
import hxd.Key;
import cerastes.ui.Button;
import data.Flow.ChoiceNode;
import cerastes.LocalizationManager;
import cerastes.ui.Timeline.TimelineRunner;
#if hlimgui
import cerastes.tools.ImguiTool.ImGuiToolManager;
#end
import cerastes.SoundManager;
import cerastes.flow.Flow.FlowRunner;
import data.Flow.DialogueNode;
import cerastes.Tween;
import cerastes.Timer;
import tweenxcore.Tools.Easing;
import cerastes.Utils;
import cerastes.pass.TransitionFilter;
import cerastes.Scene;


class LDScene extends UIScene
{
	final transitionSpeed = 0.4;
	final transitionDelay = 0.15;

	var transitionTween: Tween;

	var dText: AdvancedText;
	var textTimer: Float = 0;

	public override function enter()
	{
		super.enter();

		trackCallback(
			DialogueNode.registerOnDialogue(this, onDialogue ),
			DialogueNode.unregisterOnDialogue
		);

		trackCallback(
			ChoiceNode.registerOnChoice(this, onChoice ),
			ChoiceNode.unregisterOnChoice
		);

	}

	var dialogueLines: Array<String> = [];
	var dialogueComplete: Void->Void = null;
	var dialogueObject: h2d.Object = null;

	var inDialogue = false;
	var dialogVisible = false;
	var mayukiVisible = false;

	var choiceObject: h2d.Object = null;
	var choiceNode: ChoiceNode;
	var choiceVisible = false;
	var inChoice = false;

	var bmpSpeaker: h2d.Bitmap;
	var bmpTomoko: h2d.Bitmap;


	var skipTimer: Float = 0;

	static var lastDay = 0;


	var tr: TimelineRunner;
	var speakerTR: TimelineRunner;
	var speakerPTR: TimelineRunner;
	var lastSpeaker: String;
	var lastSpeakerbmp: String;

	function createComponents()
	{
		dialogueObject = hxd.Res.ui.dialog.toObject(s2d);
		var int: h2d.Interactive = cast dialogueObject.getObjectByName("int_popup");
		int.onClick = (e) -> {
			advanceDialog();
		};

		choiceObject = hxd.Res.ui.choices.toObject(s2d);


		if( !inDialogue)
			dialogueObject.visible = false;
		choiceObject.visible = false;

		dText = cast dialogueObject.getObjectByName("txt_popup");
		dText.text = "";

	}

	function onChoice(node: ChoiceNode, runner: FlowRunner, handled: Bool )
	{
		choiceNode = node;
		startChoice();

		var btnA: Button = cast choiceObject.getObjectByName("btn_a");
		var btnB: Button = cast choiceObject.getObjectByName("btn_b");
		var btnC: Button = cast choiceObject.getObjectByName("btn_c");

		btnA.onActivate = (e) -> {
			node.next(runner, node.pins[1] );
			endChoice();
		};
		btnB.onActivate = (e) -> {
			node.next(runner, node.pins[2] );
			endChoice();
		};
		btnC.onActivate = (e) -> {
			node.next(runner, 3);
			endChoice();
		};


		return true;
	}

	function startChoice()
	{
		choiceObject.visible= true;
		inChoice = true;
		var btnA: Button = cast choiceObject.getObjectByName("btn_a");
		var btnB: Button = cast choiceObject.getObjectByName("btn_b");
		var btnC: Button = cast choiceObject.getObjectByName("btn_c");

		if( choiceNode.choiceA != null && choiceNode.choiceA.length > 0 )
		{
			btnA.text = choiceNode.choiceA;
			btnA.visible = true;
		}
		else 
			btnA.visible = false;

		if( choiceNode.choiceB != null && choiceNode.choiceB.length > 0 )
		{
			btnB.text = choiceNode.choiceB;
			btnB.visible = true;
		}
		else 
			btnB.visible = false;

		if( choiceNode.choiceC != null && choiceNode.choiceC.length > 0 )
		{
			btnC.text = choiceNode.choiceC;
			btnC.visible = true;
		}
		else 
			btnC.visible = false;

		tr = choiceObject.createTimelineRunner("appear");
		tr.play();

		choiceVisible = true;
	}

	function endChoice()
	{
		if( choiceVisible && choiceObject != null )
		{
			choiceObject.visible= false;
			choiceVisible = false;
			tr = choiceObject.createTimelineRunner("disappear");
			tr.play();
		}

		inChoice = false;
		if( canAdvance() )
		{
			advanceState();
		}
	}


	function onDialogue(node: DialogueNode, runner: FlowRunner, handled: Bool )
	{

		var r = ~/@([^@]*)@/gm;
		var processed = r.replace( node.dialogue,'☃d67822$1☃');
		dialogueLines = processed.split("\n");
		inDialogue = true;
		dialogueComplete = () -> {
			inDialogue = false;
			node.nextAll( runner );
		}

		startDialog();

		return true;
	}

	function canAdvance()
	{
		return !inChoice && !inDialogue && !GameState.flow.busy;
	}

	function endDialog()
	{
		if( dialogVisible && dialogueObject != null )
		{
			dialogueObject.visible = false;
			dialogVisible = false;
			tr = dialogueObject.createTimelineRunner("disappear");
			tr.play();

			if( mayukiVisible )
			{
				 mayukiVisible = false;
				dialogueObject.runTimeline("hide_mayuki");
			}
		}
	}

	function startDialog()
	{
		bmpSpeaker = cast ui.getObjectByName("bmp_speaker");
		bmpTomoko = cast ui.getObjectByName("bmp_tomo");
		if( !dialogVisible )
		{
			dialogueObject.visible = true;
			dialogVisible = true;

			tr = dialogueObject.createTimelineRunner("appear");
			tr.play();
		}

		for( l in dialogueLines )
		{
			if( StringTools.startsWith(l, "Mayuki:"))
			{
				mayukiVisible = true;
				dialogueObject.runTimeline("show_mayuki");
			}
		}
		

		if( !Utils.verify(dText != null,"Popup missing text") )
		{
			dialogueComplete();
			return;
		}

		advanceDialog();
	}

	function advanceDialog()
	{
		if(dText.text.length > 0 && dText.characters < dText.text.length )
		{
			dText.characters = dText.text.length;
			return;
		}

		var line = dialogueLines.shift();
		if( line == null || line.length == 0 )
		{
			inDialogue = false;
			dialogueComplete();
			return;
		}

		var t: h2d.Text = cast dialogueObject.getObjectByName("txt_popup");
		var s: h2d.Text = cast dialogueObject.getObjectByName("txt_speaker");

		var speakerIdx = line.indexOf(':');
		var speaker = "";
		if( speakerIdx > 0)
		{
			speaker = StringTools.trim( line.substr(0,speakerIdx) );
			line = StringTools.trim( line.substr(speakerIdx+1) );
		}

		switch( speaker )
		{
			case "Tomoko": dText.textColor = 0xFF4646;
			case "Reia": dText.textColor = 0xda8090;
			case "Marika": dText.textColor =0x486d8f;
			case "Eliza": dText.textColor =0xffd65b;
			default: dText.textColor = 0xa0a0a0;
		}

		if( lastSpeaker != speaker )
		{
			if( speakerTR != null )
			{
				speakerTR.stop(); 
			}

			speakerTR = dialogueObject.createTimelineRunner("speaker_start");
			speakerTR.onComplete = () -> {
				speakerTR = dialogueObject.createTimelineRunner("speaker_end");
				s.text = speaker.toLowerCase();
				speakerTR.play();
			}
			speakerTR.play();

			var speakerbmp = switch( speaker.toLowerCase() )
			{
				case "eliza" | "marika" | "reia": speaker;
				case "tomoko": lastSpeakerbmp;
				case "": "";
				default: "audioonly";
			}

			if( bmpSpeaker != null )
			{
				var amt = 0.6;
				if( speaker.toLowerCase() == "tomoko")
				{
					bmpSpeaker.filter = new SubtractionFilter( { amount:amt } );
					bmpTomoko.filter = null;
				}
				else 
				{
					bmpTomoko.filter = new SubtractionFilter( { amount:amt } );
					bmpSpeaker.filter = null;
				}
			}

			if( speakerbmp != lastSpeakerbmp && bmpSpeaker != null )
			{
				if( speakerPTR != null )
				{
					speakerPTR.stop(); 
				}

				var open = () -> {
					if( speakerbmp == "") return;
					speakerPTR = ui.createTimelineRunner("speaker_change_end");
					bmpSpeaker.tile	 = Utils.getTile('atlases/ui.catlas|${speakerbmp.toLowerCase()}');
					speakerPTR.play();
					bmpSpeaker.visible = true;
				}

				if( lastSpeakerbmp == "")
				{
					open();
				}
				else  
				{

					speakerPTR = ui.createTimelineRunner("speaker_change_start");
					speakerPTR.onComplete = open;
					speakerPTR.play();
				}
						

				lastSpeakerbmp = speakerbmp;
			}
			
		}


		lastSpeaker = speaker;



		fitText( speaker, StringTools.replace( LocalizationManager.formatStr( line ),"\\n","\n") );
	}

	function fitText( speaker: String, text: String  )
	{
		var maxHeight = 70;
		
		dText.characters = 999999;
		dText.text = text;
		var cut = 99999;
		while( dText.textHeight > maxHeight )
		{
			cut = text.lastIndexOf(' ',cut-1);
			dText.text = text.substr(0, cut);
		}
		if( cut != 99999 )
		{
			var ct = text.substr(cut+1);
			if( speaker.length > 0 )
				ct = '$speaker: $ct';
			dialogueLines.unshift( ct );
		}

		dText.characters = 0;
		textTimer = 0;
	}

	public function advanceState()
	{
		return false;
	}

	public override function tick( d: Float )
	{

		if( dText == null )
			return;

		super.tick(d);

		textTimer += d;

		var spd = 0.01;

		var shouldBleep = false;
		while( textTimer > spd  )
		{
			if( dText.characters > dText.text.length )
				break;

			textTimer -= spd;
			
			dText.characters++;
			shouldBleep = true;
		}
		//if( shouldBleep )
		//	SoundManager.play("bleep");

		if( inDialogue && ( Key.isDown(Key.CTRL ) ) )
		{
			skipTimer +=d;
			var spd = 0.08;
			while( skipTimer > spd )
			{
				advanceDialog();
				skipTimer -= spd;
			}
		}

		if( canAdvance() )
		{
			if( !advanceState() )
				endDialog();
		}
	}


    public override function fadeOut( onComplete: Void -> Void )
	{
		if(transitionTween != null )
			transitionTween.abort();

		var transition = new TransitionFilter({ texture: "shd/transition_swipe.png" });
		s2d.filter = transition;
		transitionTween = new Tween( transitionSpeed, 0, 1, (v) -> { transition.pass.phase = v; }, Easing.linear, () -> {
			new Timer( transitionDelay, onComplete );
		});
	}

	public override function fadeIn( onComplete: Void -> Void )
	{
		var transition = new TransitionFilter({ texture: "shd/transition_swipe.png" });
		s2d.filter = transition;

		transitionTween = new Tween( transitionSpeed, 1, 0, (v) -> { transition.pass.phase = v; }, Easing.linear, () -> {  onComplete(); } );
	}

	// Lets just pretend this code doesn't exist and isn't working around some horrifying context clip bug
	public override function render(e:h3d.Engine)
	{
		var oldW = e.width;
		var oldH = e.height;

		@:privateAccess
		{
			#if js
			e.width = 1280;
			e.height = 720;
			#else
			e.width = s2d.width;
			e.height = s2d.height;
			#end
			s2d.render(e);
			e.width = oldW;
			e.height = oldH;
		}
	}
}